import React, { useEffect, useState } from 'react';
import Dialog from './Dialog/Dialog';
import { PopWell } from './Dialog/PopParts';
import Icona from './Icona/Icona';
import FlatIcon from './Icona/FlatIcon';
import { chapters } from './Guide pages/guideContent';
import './Guide pages/guide.css';

const twoDigits = (n) => String(n).padStart(2, "0");

const GuideDialog = ({ guide, showGuide }) => {
    //chapter: indice del capitolo aperto, null = indice della guida
    const [chapter, setChapter] = useState(null);
    const [page, setPage] = useState(0);

    useEffect(() => {
        if(guide) {
            setChapter(null);
            setPage(0);
            setTimeout(() => {
                let d = document.querySelector("#guide-dialog");
                if(d) {
                    d.style.opacity = null;
                    d.classList.add("fade-in");
                }
            }, 10);
        }
    }, [guide]);

    //a ogni cambio di scheda si riparte dall'inizio del contenuto
    useEffect(() => {
        const content = document.querySelector("#guide-dialog .pop-well-scroll");
        if(content) {
            content.scrollTop = 0;
        }
    }, [chapter, page]);

    const close = () => {
        let d = document.getElementById("guide-dialog");
        d.classList.remove("fade-in");
        d.style.opacity = null;
        d.classList.add("fade-out");

        setTimeout(() => {
            showGuide(false);
        }, 100);
    }

    const openChapter = (index) => {
        setChapter(index);
        setPage(0);
    }

    if(!guide) {
        return <></>;
    }

    //INDICE DEI CAPITOLI
    if(chapter === null) {
        const [first, ...others] = chapters;
        return (
            <Dialog id="guide-dialog" title="La guida vincente" plate="banner" className="guide-shell" onClose={close}>
                <PopWell scroll className="guide-index">
                    <span className="pop-cap">Scegli un capitolo</span>

                    <button type="button" className="guide-tile guide-hero pop-g-fire pop-gloss" onClick={() => openChapter(0)}>
                        <span className="guide-tile-pop"><Icona kind={first.icon} size={90} /></span>
                        <span className="guide-tile-main">
                            <span className="guide-kicker">CAPITOLO 01</span>
                            <span className="guide-tile-title">{first.title}</span>
                            <span className="guide-tile-meta">{first.schede.length} schede</span>
                        </span>
                        <span className="guide-tile-arrow"><FlatIcon name="next" size={26} /></span>
                        <span className="guide-badge">INIZIA DA QUI</span>
                    </button>

                    <div className="guide-grid">
                        {others.map((ch, i) => (
                            <button key={ch.title} type="button" className={"guide-tile pop-g-" + ch.color + " pop-gloss"} onClick={() => openChapter(i + 1)}>
                                <span className="guide-tile-pop"><Icona kind={ch.icon} size={66} /></span>
                                <span className="guide-num">{twoDigits(i + 2)}</span>
                                <span className="guide-tile-main">
                                    <span className="guide-tile-title">{ch.title}</span>
                                    <span className="guide-tile-meta">{ch.schede.length} schede</span>
                                </span>
                                <span className="guide-tile-arrow"><FlatIcon name="next" size={20} /></span>
                            </button>
                        ))}
                    </div>
                </PopWell>
            </Dialog>
        );
    }

    //SCHEDA DI UN CAPITOLO
    const ch = chapters[chapter];
    const scheda = ch.schede[page];
    const isFirst = page === 0;
    const isLast = page === ch.schede.length - 1;

    return (
        <Dialog
            id="guide-dialog"
            className="guide-shell"
            title={ch.title}
            icon={ch.icon}
            plate={ch.color}
            onClose={close}
            cancel={() => {
                if(isFirst) {
                    setChapter(null);
                } else {
                    setPage(page - 1);
                }
            }}
            cancelTxt={isFirst ? "Indice" : "Indietro"}
            cancelIcon="back"
            actions={[{
                id: "guide-next",
                color: "green",
                txt: isLast ? "Fine" : "Avanti",
                iconEnd: isLast ? "check" : "next",
                onClick: () => {
                    if(isLast) {
                        setChapter(null);
                    } else {
                        setPage(page + 1);
                    }
                },
            }]}
        >
            <div className="guide-progress">
                <span className="guide-progress-txt">Scheda {page + 1} di {ch.schede.length}</span>
                <div className="guide-segs" style={{ gridTemplateColumns: `repeat(${ch.schede.length}, minmax(0, 1fr))` }}>
                    {ch.schede.map((s, i) => (
                        <div key={s.title} className={"guide-seg " + (i <= page ? "pop-g-" + ch.color : "guide-seg-off")}></div>
                    ))}
                </div>
            </div>

            <PopWell scroll className="guide-page">
                <div className="guide-intro">
                    <h3 className="guide-h">{scheda.title}</h3>
                    {scheda.lead && <p className="guide-lead">{scheda.lead}</p>}
                </div>
                {scheda.body(ch.color)}
            </PopWell>
        </Dialog>
    );
}

export default GuideDialog;
